// Axios
import { AxiosResponse } from "axios";
import { _axios } from "../../Base_Axios_Config/_axios";
// Axios

// Models
import { I_BasicData, I_Message } from "../../../Models/interfaces";
// Models

export const getBasicInformationsService = (_data: {
  userToken: string;
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: I_BasicData;
  }>
> => {
  return _axios.get("/base-information?sometestparamters", {
    headers: {
      Authorization: `Bearer ${_data.userToken}`,
    },
  });
};
